<template>
  <div>
    <div class="wreppar">
      <div class="headers">
        <Header></Header>
      </div>
      <div class="centent">
        <div class="center">
          <div class="centent_left">
            <div class="centent_child">
              <p class="center_guan">联系我们</p>
              <div class="lian_img">
                <img src="../../assets/map.jpg" alt />
              </div>
            </div>
            <div class="centent_bottom">
              <p>地址：北京市海淀区</p>
              <p>电话：400-628-6819</p>
              <p>E-mail：info@19road.com</p>
              <p>咨询电话：400-628-6819</p>
              <p>十九路（北京）体育文化传播有限公司</p>
            </div>
          </div>
          <div class="centent_right">
            <div class="re_dian">
              <p class="dian_shi">十九路</p>
              <p class="dian_wen">MORE</p>
            </div>
            <div class="dian_center">
              <p>关于我们</p>
              <p>联系我们</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>  
<script >
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
export default {
  data() {
    return {};
  },
  components: { Header, Footer },
  watch: {},
  mounted() {},
  methods: {}
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.wreppar {
  width: 100%;
  cursor: default;
}
.headers {
  width: 100%;
}
.centent {
  width: 100%;
  padding-top: 1.85rem;
  margin-bottom: 0.6rem;
}
.center {
  width: 76%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.centent_left {
  width: 71%;
}

.re_dian {
  width: 100%;
  border-bottom: solid 2px #e50005;
  display: flex;
  justify-content: space-between;
}
.dian_shi {
  font-size: 0.2rem;
  background: #e50005;
  line-height: 0.4rem;
  color: #fff;
  padding: 0 0.3rem;
  border-radius: 5px 5px 0 0;
}
.dian_wen {
  font-size: 0.2rem;
  color: #e50005;
  line-height: 0.4rem;
}
.dian_center {
  width: 100%;
}
.dian_center p {
  font-size: 0.2rem;
  line-height: 1rem;
  border-bottom: solid 1px #ccc;
}
.centent_right {
  width: 26%;
  margin-top: 0.6rem;
}
.centent_child {
  margin-top: 0.3rem;
}
.center_guan {
  font-size: 0.24rem;
  font-weight: bold;
}
.centent_bottom {
  font-size: 0.2rem;
  line-height: 0.3rem;
}
.lian_img {
  width: 7.8rem;
  height: 3.6rem;
}
.lian_img img {
  width: 7.8rem;
  height: 3.6rem;
}
</style>  


// WEBPACK FOOTER //
// src/components/page/contact.vue